module.exports = __webpack_public_path__ + "user--placeholder.png";